import React from "react";
import previewImage from "../../project_previews/inanimate48.jpg"; // Adjust the path accordingly


function Inanimate48() {
  return (
      <div
      name="inanimate48"
      className="min-h-screen w-full bg-[#0a192f] text-gray-300 pt-[80px] pb-28 xl:pb-24 flex flex-col items-center"
      >
        <div className="w-full bg-[#0a192f] text-center py-8">
        <h1 className="text-4xl font-bold text-cyan-500">Inanimate 48</h1>
        </div>


        <img
        src={previewImage}
        alt="Preview"
        className="w-[600px] h-auto rounded-lg shadow-lg mb-4"
        />

        <div className="w-full lg:w-[60%] text-lg lg:text-4xl text-left leading-relaxed mb-4">
        <p><b>TLDR:</b> From 2019-2024 I ran an virtual 48 hour dance-meets-film festival, 
        designed to give back to the community and encourage artists to break out of their 
        norms in apparatus based dance. Over 200 people participated in 5 events.
        </p>
        </div>

        <br></br>  

        <div className="w-full lg:w-[60%] text-lg lg:text-xl text-left">
        <p>In 2018, I felt constrained by the mainstream perfornmance outlets for pole dance, most of which were competitive. I dreamted of an event that opened up the world of possibilities. 
          Nothing like this existed, so I created it. Inanimate 48 was a virtual festival that challenged artists to create a dance film in 48 hours, with the only requirement being that 
          they use a weight bearing apparatus of their choice. There were really no other rules. The festival was open to all artists, and I was thrilled to see the diversity of work that came out of it.
          The event charged a small fee, part of which was donated to various charitable causes. Each year I recruited what evolved from "judges" to "curators": people that could review submitted works, and
          with their given expertise, shortlist their favorites a highlight for others to watch. The festival ran for 5 years, and over 200 participants submitted works. I am proud of the community that was built around this event, and the work that was created.
        </p>
        <br></br>
        <p>I concluded Inanimate 48 in 2024, but the website and collection of works remain available for viewing.</p>
        <br></br>
        <p style={{ color: "#00FF00" }}><a href="https://inanimatedance.com/"><u>Visit the Inanimate 48 website</u></a></p>

        </div>

      </div>
    );

}
export default Inanimate48;